// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bSYK","field":"styles_field__1YXpw","fieldCol":"styles_fieldCol__3QRF1","diffCol":"styles_diffCol__N_njd","diff":"styles_diff__Tb9dq"};